module.exports = __webpack_public_path__ + "static/program_paradigms-0742a477958f39fcada9637b5028ba0a.png";